import { LocationDescriptor } from 'history';
import { Stack } from '@rossum/ui/material';
import { GridRenderCellParams } from '@rossum/ui/x-data-grid-pro';
import { Filename } from './Filename';
import { StyledLink } from './StyledLink';

const DEFAULT_WIDTH = 170;

export const RenderWorkflowFilenameCell = (
  props: GridRenderCellParams<{ id: number }, string> & {
    onMouseOver: () => void;
    onMouseOut: () => void;
    to: LocationDescriptor;
  }
) => {
  const { to, onMouseOver, onMouseOut, value: originalFileName } = props;

  const estimatedFilenameLength = props.colDef.width ?? DEFAULT_WIDTH;

  return (
    <Stack alignItems="center" direction="row" width="100%">
      <StyledLink
        to={to}
        sx={{
          height: '48px',
          display: 'flex',
          alignItems: 'center',
        }}
        onMouseOver={onMouseOver}
        onMouseLeave={onMouseOut}
      >
        <Filename
          status="in_workflow"
          disabled={false}
          estimatedFilenameLength={
            estimatedFilenameLength > 0 ? estimatedFilenameLength : 25
          }
          originalFileName={originalFileName}
        />
      </StyledLink>
    </Stack>
  );
};
